<template>
  <div class="">

    <!-- intro -->
    <section>
      <b-container fluid>
        <b-row class="intro-section landing-hero-row mx-0">
          <b-col xl="12" lg="12" md="12" class="px-3 landing-hero-headlines-col">
            <div class="text-section text-center">
              <h2 class="mb-3">{{ langDec.landing_hero_line1 }}</h2>
              <h2>{{ langDec.landing_hero_line2 }}</h2>
              <h2>{{ langDec.landing_hero_line3 }}</h2>

            </div>
          </b-col>
          <b-col v-if="googleplay || applestore" xl="12" lg="12" md="12" class="landing-hero-stores-col px-3">
            <div class="landing-hero-stores">
                <b-button v-if="applestore" @click="goTowebsite(applestore)" class="carousel-btn carousel-btn-1 landing-hero-store-btn px-4 py-2 mb-2" variant="dark">
                  <div
                    class="store-badge-inner carousel-btn-in-div px-3"
                    :class="{ 'store-badge-inner--en': !isAr }"
                  >
                    <div class="store-badge-inner__icon store-badge-inner__icon--apple">
                      <img class="store-badge-inner__apple-img" src="../assets/images//Apple_logo_white.svg.png" alt="">
                    </div>
                    <div class="carousel-btn-in-div-text store-badge-inner__text">
                      <span>{{ langDec.nav_available_on }}</span>
                      <br>
                      <span>App Store </span>
                    </div>
                  </div>
                </b-button>
                <b-button v-if="googleplay" @click="goTowebsite(googleplay)" class="carousel-btn carousel-btn-2 landing-hero-store-btn px-4 py-2 mb-2" variant="primary">
                  <div
                    class="store-badge-inner px-3"
                    :class="{ 'store-badge-inner--en': !isAr }"
                  >
                    <div class="store-badge-inner__icon store-badge-inner__icon--google">
                      <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0,0h40v40H0V0z"></path><g><path d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z" fill="#EA4335"></path><path d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z" fill="#FBBC04"></path><path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z" fill="#4285F4"></path><path d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z" fill="#34A853"></path></g></svg>
                    </div>
                    <div class="carousel-btn-in-div-text store-badge-inner__text">
                      <span>{{ langDec.nav_available_on }}</span>
                      <br>
                      <span>Google Play</span>
                    </div>
                  </div>
                </b-button>
            </div>            
          </b-col>          
        </b-row>
      </b-container>
    </section>


    <!-- whatWeAdvice -->
    <section>
      <div class="gridSection whatWeAdvice">
        <b-container>
          <header class="section-header">
            <h2>{{ langDec.landing_platform_title }}</h2>
          </header>
          <div class="section-content">
            <p class="description">{{ langDec.landing_platform_lead }}</p>
                <!--<h2>شغف . دافعية . إنجاز . تميز</h2>-->
            <br>
            <p class="description-link">{{ langDec.landing_what_we_offer }}</p>            
            <div class="row">
              <div class="col-md-4">
                <div class="greenBox">
                  <div class="greenBox-icon">
                    <img class="gridSection-img" src="../../src/assets/images/landingpage/whatWeAdvice-1.png" alt="logo" />
                  </div>
                  <h3>{{ langDec.landing_box_psych_support }}</h3>
                </div>
              </div>
              <div class="col-md-4">
                <div class="greenBox">
                  <div class="greenBox-icon">
                    <img class="gridSection-img" src="../../src/assets/images/landingpage/whatWeAdvice-2.png" alt="logo" />
                  </div>
                  <h3>{{ langDec.landing_box_clubs }}</h3>
                </div>
              </div>
              <div class="col-md-4">
                <div class="greenBox">
                  <div class="greenBox-icon">
                    <img class="gridSection-img" src="../../src/assets/images/landingpage/whatWeAdvice-3.png" alt="logo" />
                  </div>
                  <h3>{{ langDec.landing_box_trauma }}</h3>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="greenBox">
                  <div class="greenBox-icon">
                    <img class="gridSection-img" src="../../src/assets/images/landingpage/whatWeAdvice-4.png" alt="logo" />
                  </div>
                  <h3>{{ langDec.landing_box_check_self }}</h3>
                </div>
              </div>
              <div class="col-md-4">
                <div class="greenBox">
                  <div class="greenBox-icon">
                    <img class="gridSection-img" src="../../src/assets/images/landingpage/whatWeAdvice-5.png" alt="logo" />
                  </div>
                  <h3>{{ langDec.landing_box_webinars }}</h3>
                </div>
              </div>
              <div class="col-md-4">
                <div class="greenBox">
                  <div class="greenBox-icon">
                    <img class="gridSection-img" src="../../src/assets/images/landingpage/whatWeAdvice-6.png" alt="logo" />
                  </div>
                  <h3>{{ langDec.landing_box_consultations }}</h3>
                </div>
              </div>
            </div>
            <b-button class="px-4 py-2 my-4" variant="primary">   
              <span>{{ langDec.landing_download_app }}</span>
            </b-button> 
          </div>
        </b-container>
      </div>
    </section>


    <!-- Sessions -->
    <section class="scheduled-Sessions">
      <div class="sessions-section">
        <b-container fluid class="scheduled-sessions-wrap px-2 px-md-3">
        <b-row class="mx-0" :class="isAr ? 'text-right' : 'text-left'" style="padding-bottom: 20px;">
          <b-col xl="6" lg="6" md="12" class="mt-3 mt-xl-4" style="display: flex;">
            <div class="pt-md-5 mt-md-5 pr-md-4 px-2 px-md-0 sessions-copy" style="align-items: start; color: white; margin-bottom: 15px;">
              <h3 class="mb-4 mb-md-5 sessions-copy__title">
                {{ langDec.landing_sessions_title }}
              </h3>
              <div class="sessions-copy__body">
                <p>
                  {{ langDec.landing_sessions_p1 }}
                </p>
                <p>
                  {{ langDec.landing_sessions_p2 }}
                </p>
                <p>
                  {{ langDec.landing_sessions_p3 }}
                </p>
                <p>
                  {{ langDec.landing_sessions_p4 }}
                </p>
              </div>
            </div>
          </b-col>
          <b-col xl="6" lg="6" md="12">
            <div class="text-center py-3 py-xl-0 sessions-img-wrap">
              <img
                class="sessions-hero-img"
                src="../assets/images/landingpage/whatWeAdvice-6.png"
                alt=""
              />
            </div>
          </b-col>
        </b-row>

        <template v-if="googleplay || applestore">
        <b-row class="mx-0 mt-2 mt-md-3 pb-4 button-section button-section-row">
              <b-col cols="12" class="landing-sessions-stores-col px-3">
                <div class="landing-hero-stores landing-hero-stores--sessions">
                <b-button v-if="applestore" @click="goTowebsite(applestore)" class="carousel-btn carousel-btn-1 landing-hero-store-btn px-4 py-2 mb-2" variant="dark">
                  <div
                    class="store-badge-inner carousel-btn-in-div px-3"
                    :class="{ 'store-badge-inner--en': !isAr }"
                  >
                    <div class="store-badge-inner__icon store-badge-inner__icon--apple">
                      <img class="store-badge-inner__apple-img" src="../assets/images/Apple_logo_white.svg.png" alt="">
                    </div>
                    <div class="carousel-btn-in-div-text store-badge-inner__text">
                      <span>{{ langDec.nav_available_on }}</span>
                      <br>
                      <span>App Store </span>
                    </div>
                  </div>
                </b-button>
                <b-button v-if="googleplay" @click="goTowebsite(googleplay)" class="carousel-btn carousel-btn-2 landing-hero-store-btn px-4 py-2 mb-2" variant="primary">
                  <div
                    class="store-badge-inner px-3"
                    :class="{ 'store-badge-inner--en': !isAr }"
                  >
                    <div class="store-badge-inner__icon store-badge-inner__icon--google">
                      <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0,0h40v40H0V0z"></path><g><path d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z" fill="#EA4335"></path><path d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z" fill="#FBBC04"></path><path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z" fill="#4285F4"></path><path d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z" fill="#34A853"></path></g></svg>
                    </div>
                    <div class="carousel-btn-in-div-text store-badge-inner__text">
                      <span>{{ langDec.nav_available_on }}</span>
                      <br>
                      <span>Google Play</span>
                    </div>
                  </div>
                </b-button>
                </div>
              </b-col>
        </b-row>
        </template>
        </b-container>
      </div>
    </section>


    <!-- patients -->
    <section>
      <articles :seeMoreBtn="true" :loadMore="false" :pageSize="4" cols="3" :title="langDec.landing_patients_title" :info="langDec.landing_patients_info"></articles>
      <div style="display: flex;justify-content: center;">
        <b-button class="block px-4 py-2 my-5" variant="primary">   
          <span @click="goToRoute('articles', '')">{{ langDec.landing_patients_more }}</span>
        </b-button> <!-- -->
      </div>
    </section>


    <!-- club -->
     <section>
      <div class="gridSection club">
        <b-container>         
          <div class="section-content">
            <div class="row align-items-center club-row mx-0">
              <div class="col-md-6 col-sm-12 col-xs-12 club-text-col order-2 order-md-1">
                <header class="section-header club-section-header">
                  <h2>{{ langDec.landing_club_title }}</h2>
                </header>
                <div class="transBox">
                  <div>
                    <div>
                      <p class="landing-club-body">
                        {{ langDec.landing_club_body }}
                      </p>
                    </div>

                    <b-button class="px-4 py-2 club-read-more-btn" variant="primary">
                      <span @click="goToRoute('clubs', '')">{{ langDec.landing_club_read_more }}</span>
                    </b-button>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-xs-12 club-img-col order-1 order-md-2">
                <div class="transBox">
                  <div class="transBox-icon club-transBox-icon">
                    <img class="gridSection-img club-hero-img" src="../../src/assets/images/landingpage/club.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </div>
    </section>

    <!-- experts carousel -->
    <section>
      <expert-carousel :fetch-all="true" :page-size="20"></expert-carousel>
    </section>


    <!-- exams -->
    <section class="exams flex">
      <div >
        <div>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="header">
                <div class="section-header">
                  <h2>{{ langDec.landing_exams_title }}</h2>
                  <div class="description">
                    <p>
                      <b>{{ langDec.landing_exams_lead_bold }}</b>
                      <br><br>
                      {{ langDec.landing_exams_quote }}
                    </p>
                  </div>
                   <div class="action-btns mt-5">
                    <b-button class="px-4 py-3 mx-4 my-3" variant="light">   
                      <span>{{ langDec.landing_exams_btn_adults }} <img class="mr-2" src="../assets/images/nextIcon.png"></span>
                    </b-button>
                    <b-button class="px-4 py-3 mx-4 my-3" variant="light">   
                      <span>{{ langDec.landing_exams_btn_teens }} <img class="mr-2" src="../assets/images/nextIcon.png"></span>
                    </b-button>
                  </div> <!-- -->
                </div>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </section>


    <!-- blogs -->
    <section>
      <div class="gridSection blog">
        <b-container>
          <header class="section-header blog-section-header">
            <h2>{{ langDec.landing_blog_title }}</h2>
            <div class="blog-section-header__actions">
              <b-button @click="goToBlogRoute('articles')" class="px-4 py-2" variant="primary">   
                <span>{{ langDec.landing_blog_all }}</span>
              </b-button>
            </div>
          </header>
          <div class="section-content mt-5">
            <div class="row">
              <div  v-for="item in blogs" :key="item.slug" class="col-md-4 col-sm-6 col-xs-6">
                <div @click="goToBlogRoute('article' , item.slug)" class="transBox">
                  <div class="transBox-icon">
                    <img class="gridSection-img"  :src="'https://api.takhatty.com/' + item.imageUrl" alt="logo" />
                  </div>
                  <div>
                    <div class="mt-2 px-2">
                      <div style="display: flex;">
                        <div class="time pt-1">
                          {{ new Date(item.publishDateTime).toLocaleDateString(blogLocale, { day: 'numeric', month: 'long', year: 'numeric' }) }}
                        </div>
                        <!-- <div class="likes" style="margin-right: auto;">
                          50 <span class="mr-2"><img style="width: 30px;" src="../../src/assets/images/likesicon.png"></span>
                        </div> -->
                      </div>
                      <h5>
                        {{ item.title }}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
          </div>
        </b-container>
      </div>
    </section>
  </div>
</template>


<script>
  import { sendRequest } from '../utils/RequestHelper.js'
  import { mapGetters } from 'vuex'
  import expertCarousel from "../components/ExpertCarousel.vue"
  import articles from "../components/ArticlesSection.vue"
  export default {
    name: 'Home',
    data() {
      return {

        // blogs
        blogIsLoading: true,
        blogs: [],
        googleplay: process.env.VUE_APP_GOOGLEPLAYLINK,
        applestore: process.env.VUE_APP_APPLESTORELINK
      }
    },
    components: {
      expertCarousel,
      articles
    },
    computed: {
      ...mapGetters(['getLangData', 'getlang']),
      langDec() {
        return this.getLangData || {}
      },
      blogLocale() {
        return this.getlang === 'ar' ? 'ar-EG' : 'en-US'
      },
      isAr() {
        return this.getlang === 'ar'
      },
    },
    methods: {
      goTowebsite(link) {
        window.open(link, "_blank");
      },
      goToRoute(name) {
        this.$router.push({
          name
        })
      },


      // blogs
      goToBlogRoute(name, id) {
        this.$router.push({
          name,
          params: {
            id: id
          }
        })
      },
      loadBlogs() {
        this.blogIsLoading = true;
        let body = {
          pageSize: 3,
          pageNumber: 1,
          isPublished: true,
          searchTerm: ''
        }
        this.blogIsLoading = true;
        sendRequest('post', `Blog/search`, true, body,
          (response) => {
            this.blogs = response.data.data.items;
            this.blogIsLoading = false;
          },
          () => {
            this.blogIsLoading = false;
            this.alertType = 'danger';
            this.alertText = 'Error loading data';
          }
        );
      }
    },
    created() {
      this.loadBlogs()
    }
  }
</script>

<style scoped>
  .pageContent{
    padding: 0 !important;
    margin: 0 !important;
  }

  .landing-club-body {
    white-space: pre-line;
    text-align: start;
  }

  /* شارات المتجر: EN = نص | أيقونة ، AR = أيقونة | نص — مسافة ثابتة بينهما */
  .store-badge-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    direction: ltr;
    gap: 0.875rem;
  }

  .store-badge-inner--en {
    flex-direction: row-reverse;
  }

  .store-badge-inner__icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .store-badge-inner__icon--apple {
    width: 35px;
    height: 35px;
    color: #fff;
  }

  .store-badge-inner__icon--google {
    width: 40px;
    height: 40px;
  }

  .store-badge-inner__apple-img {
    width: 35px;
    height: auto;
    margin-top: -3px;
    display: block;
  }

  .store-badge-inner__text {
    font-size: 20px;
    line-height: 1.25;
    text-align: start;
  }

  .club .section-content {
    text-align: start;
  }

  .club-section-header {
    text-align: start;
  }

  .club-read-more-btn {
    margin-top: 0.5rem;
  }

  .club-transBox-icon {
    display: flex;
    margin-bottom: 25px;
    justify-content: center;
  }

  @media (min-width: 768px) {
    .club-transBox-icon {
      justify-content: center;
    }
  }

  .blog-section-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
  }

  .blog-section-header__actions {
    margin-inline-start: auto;
  }

  .intro-section {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(../assets/images/introBG.png);
    background-size: cover;
    background-position: center;
    width: auto;
    height: 600px !important;
  }

  /* Hero: headlines centered, store badges grouped at bottom — flex-start follows html dir (AR→right, EN→left) */
  .landing-hero-row.intro-section {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    min-height: 600px;
  }

  .landing-hero-headlines-col {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 0;
  }

  .landing-hero-stores-col {
    flex: 0 0 auto;
    margin-top: auto;
    padding-top: 1rem;
    padding-bottom: 1.25rem;
  }

  .landing-hero-stores {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem 1rem;
    justify-content: center;
    width: 100%;
  }

  /* Sessions block: keep badges aligned to start (follows html dir) */
  .landing-hero-stores--sessions {
    justify-content: flex-start;
  }

  .landing-hero-store-btn {
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-inline: 0 !important;
  }
  .text-section h2 {
    font-size: 40px !important;
    font-weight: bolder !important;
    color: white;
  }

  /* gives us */
  .gridSection{
    text-align: center;
    padding: 50px 0px;
    margin: 30px 0px;
  }
  .section-header h2{
    margin-bottom: 20px;
    margin-bottom: 30px;
    font-weight: bolder !important;
  }
  .section-content p {
    margin-bottom: 10px;
    margin-bottom: 40px;
  }
  .gridSection .description{
    color: grey;
    font-size: 20px;
  }
  .gridSection .description-link{
    color: #006633;
    font-weight: bold;
    font-size: 20px;
    margin-top: 20px;
  }
  .greenBox {
    border-radius: 10px;
    background-color: #e7f0e7;
    padding: 20px;
    text-align: center;
    margin-bottom: 20px;
  }
  .greenBox-icon img{
    width: 150px;
    height: 150px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 30px !important;
  }
  .greenBox-icon i {
    font-size: 24px;
    color: #000000;
  }


.ht{
  background-color: red;
}

  /* sessions */
  .sessions-section {
    background-image: url(../assets/images/landingpage/sessions-section-bg.png);
    background-size: cover;
    background-position: right top;
    /* height: 700px; */
    width: auto;
  }

  .sessions-copy__title {
    font-size: clamp(1.35rem, 4vw + 0.5rem, 2.75rem);
  }

  .sessions-copy__body {
    font-size: clamp(0.95rem, 2vw, 1.25rem);
  }

  .sessions-hero-img {
    max-width: 100%;
    width: min(320px, 100%);
    height: auto;
  }

  .transBox-icon img{
    width: 250px;
    height: 250px;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 10px;
    margin-bottom: 10px;
    margin-top: 30px !important;
  }
  .transBox h5{
    font-size: 17px !important;
    font-weight: bold;
    text-align: start;

  }
  .transBox .link{
    text-align: start !important; 
    font-size: 14px;
    margin-top: 15px;
    color: #006633;
  }

  /* club */
  .club{
    padding: 40px 0px;
    padding-top: 70px;
    background-color: #fafafa;
    z-index: 1; /* Set a higher z-index value */
  }
  .club .section-header{
    text-align: start;
  }
  .club .club-hero-img{
    float: none;
    width: 400px;
    height: 400px;
    margin-top: 0 !important;
    display: block;
    margin-inline: auto;
    max-width: 100%;
  }
  .club .transBox{
    text-align: start;
  }


  /* experts */
  .experts .transBox img{
    border-radius: 500%;
    width: 200px !important;
    height: 200px !important;
  }

  .experts .transBox-text{
    color: black !important;
    box-shadow: unset !important;
  }
  .experts .section-header{
    color: black !important;
  }
  .experts .carousel-item{
    bottom: 50% !important;
    text-align: center;
  }
  .experts h5{
    text-align: center;
    margin-bottom: 15px;
    margin-top: 30px;
  }
  .experts .description{
    color: grey;
    font-size: 17px;
    text-align: center;
    padding: 5px 10px;
  }
  .experts .description b{
    color: rgb(26, 26, 26);
    font-size: 20px;
  }


  .exams{
    background-image: url('../assets/images/examsBG.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    color: white;
    padding: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 22px;
  }
  .exams .description{
    font-size: 17px;
  }
  .exams .action-btns .btn{
    color: #006633 !important;
  }


  .blog .gridSection-img{
    width: 100%;
    height: 250px;
    object-fit: cover;
  }
  .blog .transBox .time{
    text-align: start !important;
    font-size: 12px;
    color: #ABABAB;
    margin-bottom: 15px;
  }
  .blog .transBox .likes{
    text-align: start !important;
    font-size: 12px;
    color: #ABABAB;
    margin-bottom: 15px;
  }
  .blog .transBox{
    cursor: pointer;
  }
  .blog .transBox h5{
    transition: 500ms;
  }
  .blog .transBox .gridSection-img{
    transition: 500ms;
  }
  .blog .transBox:hover .gridSection-img {
    height: 240px !important;
    margin-top: -10px;
    text-decoration: underline;
  }
  .blog .transBox:hover h5 {
    margin-top: -10px;
    text-decoration: underline;
  }
  .scheduled-Sessions .button-section-row {
    justify-content: flex-start;
  }

  @media (max-width: 575.98px) {
    .scheduled-Sessions .button-section-row {
      justify-content: flex-start;
    }
  }
  .carousel-caption{
    position: relative !important;
  }
  @media (max-width: 991.98px) {
    .text-section h2 {
      font-size: 30px !important;
      font-weight: bolder !important;
      color: white;
    }
    .button-section .btn{
      font-size: 10px !important;
    }
    .greenBox-icon img{
      width: 100px;
      height: 100px;
      margin-bottom: 10px;
      margin-top: 10px !important;
    }
    .transBox-icon img{
      width: 150px !important;
      height: 150px !important;
      margin-bottom: 10px;
      margin-top: 30px !important;
    }
    .club .club-hero-img{
      width: 300px !important;
      height: 300px !important;
      margin-bottom: 20px !important;
      margin-top: 20px !important;
    }
    
    .blog .gridSection-img{
      width: 150px !important;
      height: 130px !important;
    }
    .blog .transBox:hover .gridSection-img {
      width: 140px !important;
      height: 120px !important;
    }
  }

  @media (max-width: 767.98px) {
    .greenBox-icon img{
      width: 100px;
      height: 100px;
      margin-bottom: 10px;
      margin-top: 10px !important;
    }
    .club{
      padding: 20px 0px;
    }
    .club .club-hero-img{
      width: 300px !important;
      height: 300px !important;
      margin-bottom: 20px !important;
      margin-top: 20px !important;
      margin-inline: auto !important;
      display: block;
    }
    .transBox h5{
      font-size: 17px !important;
      text-align: center;

    }
    .transBox .link{
      text-align: center !important; 
    }

    .experts{
      display: none;
    }

    .exams{
      padding: 50px 40px;
      padding-top: 150px;
    }

    .blog .gridSection-img{
      width: 250px !important;
      height: 220px !important;
    }

    .blog .transBox:hover .gridSection-img {
      width: 120px !important;
      height: 100px !important;
    }
  }

  /* tablet */
  @media (min-width: 768px) and (max-width: 991.98px) {

  }

  @media (max-width: 575.98px) {
    .intro-section {
      height: auto !important;
      min-height: 420px;
      padding-top: 2rem !important;
      padding-bottom: 2rem !important;
    }

    .landing-hero-row.intro-section {
      min-height: 420px;
    }

    .text-section h2 {
      font-size: 26px !important;
    }

    .club .club-hero-img{
      float: none !important;
      width: min(100%, 320px) !important;
      height: auto !important;
      margin-inline: auto;
      display: block;
    }

    .exams {
      padding-top: 2rem !important;
      padding-left: 1rem !important;
      padding-right: 1rem !important;
      font-size: 1rem;
    }

    .blog .section-header {
      flex-direction: column;
      align-items: stretch;
      gap: 1rem;
    }

    .schedule-btn .carousel-btn,
    .landing-hero-store-btn {
      max-width: 100%;
    }
  }
</style>